import { render } from "./PhotoSquare.vue?vue&type=template&id=6d1dc78e&scoped=true"
import script from "./PhotoSquare.vue?vue&type=script&lang=js"
export * from "./PhotoSquare.vue?vue&type=script&lang=js"

import "./PhotoSquare.vue?vue&type=style&index=0&id=6d1dc78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1dc78e"]])

export default __exports__